import * as React from "react";
import { cn } from "../../lib/utils";

function Textarea({ className, ...props }: React.ComponentProps<"textarea">) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        "flex field-sizing-content min-h-24 w-full rounded-lg border border-input bg-card px-3.5 py-2.5 text-[15px] md:text-sm text-foreground shadow-xs leading-relaxed",
        "placeholder:text-text-tertiary",
        "transition-[border-color,box-shadow] duration-(--dur-fast) ease-(--ease-standard) outline-none",
        "hover:border-[color-mix(in_oklch,var(--input)_60%,var(--foreground))]",
        "focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/25",
        "aria-invalid:border-destructive aria-invalid:ring-destructive/20",
        "disabled:cursor-not-allowed disabled:opacity-50",
        className,
      )}
      {...props}
    />
  );
}

export { Textarea };
